const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/pages/appointment/components/SlotsPerDate.tsx';
import React from 'react';
import { Button, Typography } from '@mui/material';
import Grid from '@mui/material/Grid';
import { Theme, useTheme } from '@mui/material/styles';
import moment from 'moment';
import { GapSm } from 'App/components/Gap/Gap';
import { css } from '@emotion/css';
import { colors } from '@cistec/common_web/defs/colors';
import { useIntl } from 'react-intl';
import textMap from '../translations';
import { Slot } from 'App/defs/types';

type slotDateProps = {
    onChange: (slot: Slot) => void;
    selectedSlot: Slot | null;
    slots: any;
    date: string;
};

const cssSlotsRoot = (theme: Theme) => css`
    ${theme.breakpoints.down('md')} {
        min-width: 100%;
    }
`;

const cssSlotsGridUntilXS = (theme: Theme) => css`
    ${theme.breakpoints.between(360, 'xs')} {
        flex-basis: 25%;
        flex-grow: 0;
        max-width: 25%;
    }
`;

const cssButton = (theme: Theme) => css`
    ${theme.breakpoints.down('md')} {
        min-height: 44px;
        min-width: 100%;
        font-size: 15px;
    }
`;

const emptySlotsText = css`
    color: ${colors.grey['500']};
`;

export const SlotsPerDate = (props: slotDateProps) => {
    const { formatMessage } = useIntl();
    const theme = useTheme();
    const { onChange, selectedSlot, slots, date } = props;

    const renderSlots = (slots: Slot[]) => {
        if (slots) {
            return slots.map(slot => (
                <Grid key={slot.id} size={{ xs: 3, md: 6 }} className={cssSlotsGridUntilXS(theme)}>
                    <Button
                        size={'medium'}
                        variant={selectedSlot?.id === slot.id ? 'contained' : 'outlined'}
                        onClick={() => {
                            onChange(slot);
                        }}
                        color={selectedSlot?.id === slot.id ? 'primary' : 'secondary'}
                        className={cssButton(theme)}
                    >
                        {moment(slot.startDate).format('HH:mm')}
                    </Button>
                </Grid>
            ));
        } else {
            return (
                <Grid size={{ md: 12 }}>
                    <Typography className={emptySlotsText} align={'center'}>
                        {formatMessage(textMap.noAvailableSlots)}
                    </Typography>
                </Grid>
            );
        }
    };

    return (
        <Grid key={date} size={{ xs: 12, md: 2.4 }} className={cssSlotsRoot(theme)}>
            <Typography variant={'h6'} align={'left'}>
                {moment(date, 'DD.MM.YYYY').format('dd DD.MM.')}
            </Typography>
            <GapSm />
            <Grid container spacing={1}>
                {renderSlots(slots[date])}
            </Grid>
        </Grid>
    );
};
